// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAccountBalanceByClient } from '../../storage/actions/profile';
import { fetchWorkOrderTemplateById, setCurrentTemplate } from '../../storage/actions/workOrdersActions';
import Loader from '../../components/dashboard/common/Loader';
// eslint-disable-next-line import/no-cycle
import PageHeader from '../../components/createWorkOrderTemplate/PageHeader';
import CreateWorkOrderTemplateReduxForm from '../../components/layout/reduxForm/CreateWorkOrderTemplate';
import onSubmit from '../../utils/reduxForm/onSubmit/createWorkOrderTemplate';

const CreateAndEditWorkOrderTemplates = ({
  mainContainer,
  currentTemplate,
  fetchWorkOrderTemplateById,
  getAccountBalanceByClient,
  setCurrentTemplate,
  match,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    const init = async () => {
      getAccountBalanceByClient();

      const id = match?.params?.id;
      try {
        if (!id) {
          await setCurrentTemplate({});
        } else {
          await fetchWorkOrderTemplateById(id);
        }
        if (isMountedRef.current) {
          setIsLoading(false);
        }
      } catch {
        if (isMountedRef.current) {
          setIsLoading(false);
        }
      }
    };

    init();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

    useEffect(() => {
        if (!isLoading) {
            setTimeout(() => window.scrollTo(0, 0), 0);
        }
    }, [isLoading]);

  return (
    <div className="content content--work-order-template">
      <PageHeader isLoading={isLoading} name={!isLoading && currentTemplate?.name} />
      {
        isLoading
          ? (
            <div className="flex-box flex-center">
              <Loader />
            </div>
          )
          : (
            <CreateWorkOrderTemplateReduxForm onSubmit={onSubmit} />
          )
      }
    </div>
  );
};

const mapDispatchToProps = {
  getAccountBalanceByClient,
  fetchWorkOrderTemplateById,
  setCurrentTemplate,
};

const mapStateToProps = state => ({
  currentTemplate: state.workOrder.currentTemplate,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateAndEditWorkOrderTemplates));
